import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { fromGel } from "../config/currency";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

export default function Listings({ filter = {}, displayCurrency = "GEL" }) {
  const loadMoreRef = useRef(null);
  const scrollRef = useRef(null);
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const currentUserId = user?.uid;
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [visibleCount, setVisibleCount] = useState(12);
  const [loading, setLoading] = useState(false);
  const getBoostLevel = (listing) => {
  const now = Date.now();

  if (listing?.extraGoldUntil > now) return 3;
  if (listing?.goldUntil > now) return 2;
  if (listing?.vipUntil > now) return 1;

  return 0;
};

const isBoosted = (listing) =>
  getBoostLevel(listing) > 0;

  useEffect(() => {
  const fetchListings = async () => {
    try {
      const q = query(
  collection(db, "listings"),
  where("status", "==", "published")
);

const snapshot = await getDocs(q);
  
const now = Date.now();

const data = snapshot.docs
  .map(doc => ({
    id: doc.id,
    ...doc.data(),
  }))
  .filter(listing => listing.marketplaceType !== "renovation")
  .filter(listing => {
    // Old listings without expiresAt stay visible
    if (!listing.expiresAt) return true;

    return Number(listing.expiresAt) > now;
  });

setItems(data);

    } catch (err) {
      console.error("Error fetching listings:", err);
    }
  };

  fetchListings();
}, []);



// ✅ FILTER BY IDS (for favorites)
let itemsToUse = items;

if (filter.ids && filter.ids.length > 0) {
  itemsToUse = items.filter(item => filter.ids.includes(item.id));
}

  const sortedItems = [...itemsToUse].sort(
    (a, b) => new Date(b.createdAt || b.id) - new Date(a.createdAt || a.id)
  );

  const has = (value, filterArray) => {
    if (value == null) return false;
    return Array.isArray(value)
      ? filterArray.some(v => value.includes(v))
      : filterArray.includes(value);
  };

console.log("FILTER OBJECT:", filter);

  let filtered = sortedItems
  .map(l => {
    let amenityMatchCount = 0;

    if (filter.amenities?.length) {
      amenityMatchCount =
        l.amenities?.filter(a => filter.amenities.includes(a)).length || 0;
    }

    return { ...l, amenityMatchCount };
  })
  .filter(l => {
    
     console.log("FILTER LOCATION:", filter.location);
  console.log("LISTING LOCATION:", l.location);

    const isFirstFloor = Number(l.floor) === 1;
    const isLastFloor =
      Number(l.floor) === Number(l.totalFloors);

if (filter.ids && filter.ids.length === 0) return false;

    if (filter.userId && l.userId !== filter.userId) return false;

    if (filter.type && l.type !== filter.type) return false;
    if (
  filter.subTypes?.length &&
  !(
    Array.isArray(l.subType)
      ? l.subType.some(st => filter.subTypes.includes(st))
      : filter.subTypes.includes(l.subType)
  )
) return false;
    if (filter.conditions?.length && !has(l.condition, filter.conditions)) return false;
    if (filter.renovations?.length && !has(l.renovation, filter.renovations)) return false;
    if (filter.buildings?.length && !has(l.building, filter.buildings)) return false;
    if (filter.rooms?.length && !filter.rooms.includes(String(l.rooms))) return false;
    if (filter.bedrooms?.length && !filter.bedrooms.includes(String(l.bedrooms))) return false;
    if (filter.projects?.length && !has(l.projectType, filter.projects)) return false;
    if (filter.purpose && l.purpose !== filter.purpose) return false;
    if (filter.location?.length) {
  const valuesToCheck = [
    l.city,
    l.district,
    l.localarea,
    l.neighborhood
  ].filter(Boolean);

  const match = filter.location.some(filterVal =>
    valuesToCheck.includes(filterVal)
  );

  if (!match) return false;
}

    if (filter.openForForeign && !l.openForForeign) return false;
    if (filter.openForAgents && !l.openForAgents) return false;
    if (filter.exchangePossible && !l.exchangePossible) return false;
    if (filter.bankPayment && !l.bankPayment) return false;
    if (filter.priceNegotiable && !l.priceNegotiable) return false;

    if (filter.username && l.username !== filter.username) return false;

    if (filter.amenities?.length && l.amenityMatchCount === 0) return false;

    if (filter.price && Number(l.price_gel) > Number(filter.price)) return false;

    if (
      filter.pricePerM2 &&
      Number(l.area) > 0 &&
      Number(l.price_gel) / Number(l.area) > Number(filter.pricePerM2)
    ) return false;

    if (filter.floorFrom && Number(l.floor) < Number(filter.floorFrom)) return false;
    if (filter.floorTo && Number(l.floor) > Number(filter.floorTo)) return false;
    if (filter.notFirstFloor && isFirstFloor) return false;
    if (filter.notLastFloor && isLastFloor) return false;

    if (filter.areaFrom && Number(l.area) < Number(filter.areaFrom)) return false;
    if (filter.areaTo && Number(l.area) > Number(filter.areaTo)) return false;

    return true;
  });

const filteredSorted = filtered.sort((a, b) => {

  const aBoost = getBoostLevel(a);
const bBoost = getBoostLevel(b);

// Higher boost first
if (aBoost !== bBoost) {
  return bBoost - aBoost;
}

  // Then amenity score
  const amenityDiff =
    (b.amenityMatchCount || 0) -
    (a.amenityMatchCount || 0);

  if (amenityDiff !== 0) {
    return amenityDiff;
  }

  // Then newest
  return (
    new Date(b.createdAt || 0) -
    new Date(a.createdAt || 0)
  );
});

const visibleItems = filteredSorted
  .filter(l => !isBoosted(l))
  .slice(0, visibleCount);

const extraGoldItems = filteredSorted.filter(
  l => getBoostLevel(l) === 3
);

const goldItems = filteredSorted.filter(
  l => getBoostLevel(l) === 2
);

const vipItems = filteredSorted.filter(
  l => getBoostLevel(l) === 1
);

const VAKE_SABURTALO_GROUP = [
  "vake",
  "bagebi",
  "agaraki",
  "turtle_lake",
  "tkhinvala",
  "didi_digomi",
  "vashlijvari",
  "lisi",
  "saburtalo",
  "koshigora",
  "patara_digomi",
  "sop_digomi",
  "dighmis_tchala",
  "didgori",
];

const vakeSaburtaloApartments = items.filter(
  l =>
    l.type === "apartment" &&
    (
      VAKE_SABURTALO_GROUP.includes(l.district) ||
      VAKE_SABURTALO_GROUP.includes(l.localarea) ||
      VAKE_SABURTALO_GROUP.includes(l.neighborhood)
    )
);

useEffect(() => {
  setVisibleCount(12);
}, [filter, items]);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
    if (visibleCount >= filteredSorted.length) return;

    setLoading(true);

    setTimeout(() => {
    setVisibleCount(prev => prev + 12);
    setLoading(false);
  }, 400);
}
    },
    {
      root: scrollRef.current,
      threshold: 0.5,
    }
  );

  if (loadMoreRef.current) {
    observer.observe(loadMoreRef.current);
  }

  return () => observer.disconnect();
}, [visibleCount, filteredSorted.length]);


const renderCard = (l, keyPrefix = "") => {
  const gelPrice = Number(l.price_gel);

const boostLevel = getBoostLevel(l);


  const shownPrice =
    Number.isFinite(gelPrice) && gelPrice > 0
      ? fromGel(gelPrice, displayCurrency)
      : null;


console.log("Items:", items.length);
console.log("Filtered:", filtered.length);
console.log("FilteredSorted:", filteredSorted.length);
console.log("Visible:", visibleItems.length);

console.log("Extra Gold:", extraGoldItems.length);
console.log("Gold:", goldItems.length);
console.log("VIP:", vipItems.length);
console.log("Vake:", vakeSaburtaloApartments.length);


  return (
    <div
      key={`${keyPrefix}${l.id}`}
      className="listing-card"
      style={{ position: "relative" }}
      onClick={() => {
        sessionStorage.setItem(
          "listingScroll",
          window.scrollY
        );

        navigate(`/listing/${l.id}`);
      }}
    >

      {isBoosted(l) && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            background:
              getBoostLevel(l) === 3
                ? "#f59e0b"
                : getBoostLevel(l) === 2
                ? "#eab308"
                : "#16a34a",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          {getBoostLevel(l) === 3
  ? `🜲 ${t("listing.extraGold")}`
  : getBoostLevel(l) === 2
  ? `✩ ${t("listing.gold")}`
  : t("listing.vip")}
        </div>
      )}



      {Array.isArray(l.photos) && l.photos.length > 0 && (
        <img src={l.photos[0]} alt="" />
      )}


      <div className="listing-top-row">
        <div className="listing-type">
          {t(`property.type.${l.type}`)} ·{" "}
          {t(`property.purpose.${l.purpose}`)}
        </div>

      <div className="listing-location">
  {[
  l.city ? t(`location.${l.city}`) : null,
  (l.street?.[i18n.language] ||
   l.street?.ka ||
   l.street?.en ||
   "") + (l.streetNumber ? ` ${l.streetNumber}` : "")
]
.filter(Boolean)
.join(", ")}
</div>
   </div>

      <div
  className="listing-price-row"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <div className="listing-price">
    {Number.isFinite(shownPrice)
      ? `${shownPrice.toLocaleString()} ${
          displayCurrency === "GEL" ? "₾" : "$"
        }`
      : "—"}
  </div>

  {l.accountType &&
 l.accountType !== "regular" && (
  <span className="listing-agent-badge">
    {l.accountType === "agent" && `👤 ${t("profile.agent")}`}
    {l.accountType === "agency" && `🏢 ${t("profile.agency")}`}
    {l.accountType === "developer" && `🏗️ ${t("profile.developer")}`}
  </span>
 )}
</div>

      <div className="listing-meta">
  {l.area && (
    <span>
      {l.area} {t("common.m²")}
    </span>
  )}

  {l.floor && (
    <span>
      {" "}
      · {t("floor")} {l.floor}
      {l.totalFloors ? `/${l.totalFloors}` : ""}
    </span>
  )}

  {l.rooms && (
  <span>
    {" "}
    · {t("rom.rooms")} - {l.rooms}
  </span>
)}
</div>



 {getBoostLevel(l) > 0 && (
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>

        {l.openForForeign && (
          <span className="listing-badge foreign">
            {t("listing_flagss.foreign")}
          </span>
        )}

        {l.openForAgents && (
          <span className="listing-badge agents">
            {t("listing_flagss.agents")}
          </span>
        )}

        {l.priceNegotiable && (
          <span className="listing-badge negotiable">
            {t("listing_flagss.negotiable")}
          </span>
        )}

        {l.bankPayment && (
          <span className="listing-badge mortgage">
            {t("listing_flagss.mortgage")}
          </span>
        )}

        {l.exchangePossible && (
          <span className="listing-badge exchange">
            {t("listing_flagss.exchange")}
          </span>
        )}

      </div>
    )}



      <p className="listing-description">
        {l.description}
      </p>
    </div>
  );
};




  return (
  <div className="listings-scroll" ref={scrollRef}>



{extraGoldItems.length > 0 && (
  <div style={{ marginBottom: "40px" }}>
    <h2 style={{ color: "#f59e0b", fontWeight: 800 }}>
      {t("listing.extraGoldListings")}
    </h2>

    <div style={{
      display: "flex",
      overflowX: "auto",
      gap: "16px",
      paddingBottom: "10px",
    }}>
      {extraGoldItems.map(l => renderCard(l, "extra-"))}
    </div>
  </div>
)}

{goldItems.length > 0 && (
  <div style={{ marginBottom: "24px" }}>
    <h2 style={{ color: "#eab308", fontWeight: 800 }}>
      {t("listing.goldListings")}
    </h2>

    <div style={{
      display: "flex",
      overflowX: "auto",
      gap: "16px",
      paddingBottom: "10px",
    }}>
      {goldItems.map(l => renderCard(l, "gold-"))}
    </div>
  </div>
)}

{vipItems.length > 0 && (
  <div style={{ marginBottom: "24px" }}>
    <h2 style={{ color: "#16a34a", fontWeight: 800 }}>
      {t("listing.vipListings")}
    </h2>

    <div style={{
      display: "flex",
      overflowX: "auto",
      gap: "16px",
      paddingBottom: "10px",
    }}>
      {vipItems.map(l => renderCard(l, "vip-"))}
    </div>
  </div>
)}


{vakeSaburtaloApartments.length > 0 && (
  <div style={{ marginBottom: "24px" }}>
    <h2 style={{ color: "#2563eb", fontWeight: 800 }}>
      {t("listing.vakeSaburtaloApartments")}
    </h2>

    <div
      style={{
        display: "flex",
        overflowX: "auto",
        gap: "16px",
        paddingBottom: "10px",
      }}
    >
      {vakeSaburtaloApartments.map(l =>
        renderCard(l, "vake-")
      )}
    </div>
  </div>
)}


<div style={{ marginBottom: "24px" }}>
  <h2 style={{ color: "#2563eb", fontWeight: 800 }}>
    {t("listing.regularListings")}
  </h2>

  <div
    style={{
      display: "flex",
      overflowX: "auto",
      gap: "16px",
      paddingBottom: "10px",
    }}
  >
    {visibleItems.map(l => renderCard(l))}
  </div>
</div>

    {/* 🔥 infinite scroll trigger */}
    <div ref={loadMoreRef} style={{ height: 20 }} />

    {loading && <div style={{ padding: 12 }}>Loading...</div>}

    {filteredSorted.length === 0 && !loading && (
      <div style={{ padding: 12 }}>
        {t("listing.noResults")}
      </div>
    )}

  </div>
 );
}

